import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { verifyBot } from '../../data/actions/appActions';
import '../../styles/TurnstileGate.scss';

const TEST_SITE_KEY = '1x00000000000000000000AA';
const SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || TEST_SITE_KEY;

function TurnstileGate(props) {
  const widgetRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (props.botVerified) return undefined;

    let cancelled = false;
    let pollId = null;

    const tryRender = () => {
      if (cancelled) return;
      if (!window.turnstile) {
        pollId = setTimeout(tryRender, 200);
        return;
      }
      if (!widgetRef.current) return;
      try {
        widgetIdRef.current = window.turnstile.render(widgetRef.current, {
          sitekey: SITE_KEY,
          callback: (token) => {
            props.verifyBot(token);
          },
          'error-callback': () => {},
          theme: props.theme || 'auto',
        });
      } catch (err) {
        /* render race during HMR — ignore */
      }
    };

    tryRender();

    return () => {
      cancelled = true;
      if (pollId) clearTimeout(pollId);
      if (widgetIdRef.current && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (err) {
          /* widget already gone */
        }
      }
    };
  }, [props.botVerified]);

  return (
    <>
      {props.botVerified ? props.children || null : null}
      {!props.botVerified && (
        <div className="turnstileGate">
          <div className="turnstileGate__inner">
            <p className="turnstileGate__copy">
              Verifierar att du är människa…
            </p>
            <div ref={widgetRef} className="turnstileGate__widget" />
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({ botVerified: state.app.botVerified });
const mapDispatchToProps = (dispatch) => ({
  verifyBot: (token) => dispatch(verifyBot(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TurnstileGate);
